import {Injectable} from '@angular/core';
import {MissingTranslationHandler, MissingTranslationHandlerParams} from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import {MultiTranslateHttpLoader} from 'ngx-translate-multi-http-loader';

@Injectable()
export class LogMissingTranslationsInBackend extends MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams): any {
    // Triggers frontend-logger
    throw Error('Missing translation: ' + params.key);
  }
}

export function MultiTranslateHttpLoaderFactory(http: HttpClient): MultiTranslateHttpLoader {
  // Loader for the translation files
  return new MultiTranslateHttpLoader(http, [
    {prefix: './assets/i18n/shared/', suffix: '.json'},
    {prefix: './assets/i18n/member-types/', suffix: '.json'},
    {prefix: './assets/i18n/application-types/', suffix: '.json'},
    {prefix: './assets/i18n/line-of-business-types/', suffix: '.json'},
    {prefix: './assets/i18n/expert-service-types/', suffix: '.json'},
    {prefix: './assets/i18n/create-ad/', suffix: '.json'},
    {prefix: './assets/i18n/country-codes/', suffix: '.json'},
    {prefix: './assets/i18n/offer/', suffix: '.json'}
  ]);
}

